import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import React, { FC, useContext, useState } from 'react'

import { AppContext } from '../../providers/AppProvider/AppProvider'
import { TechnicianSingleSelectUI } from '../Estimates/TechnicianSelect/TechnicianSingleSelectUI'
import TreePreview from '../Inspections/TreePreview'
import InspectionList from '../Settings/Inspections/InspectionList'

interface Props {
  selectCallback: (inspectionId: string, techId: string) => void
  handleClose: () => void
}

// this component is shared between main app and dvi
const SelectDialog: FC<Props> = ({ selectCallback, handleClose }) => {
  const { technicians } = useContext(AppContext)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const [selectedId, setSelectedId] = useState<string>('')
  const [techId, setTechId] = useState('')

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      open={true}
      onClose={handleClose}>
      <DialogTitle>Assign Inspection to Repair Order</DialogTitle>
      <DialogContent sx={{ minHeight: '300px' }}>
        <Grid container direction="row" px={2} columnSpacing={4}>
          <Grid item xs={12} md={6}>
            <Stepper orientation="vertical">
              <Step active={true}>
                <StepLabel>Select Technician</StepLabel>
                <StepContent>
                  {technicians && (
                    <TechnicianSingleSelectUI
                      techs={
                        techId && technicians.find((tech) => tech.id === techId)
                          ? [technicians.find((tech) => tech.id === techId)!]
                          : []
                      }
                      techOptions={technicians}
                      handleTechChange={(newId) => setTechId(newId)}
                      sx={{ maxWidth: 'sm' }}
                    />
                  )}
                </StepContent>
              </Step>
              <Step active={true}>
                <StepLabel>Select Inspection Template</StepLabel>
                <Box ml={2}>
                  <InspectionList
                    selectedId={selectedId}
                    setSelectedId={setSelectedId}
                    hideDuplicateButton
                  />
                </Box>
              </Step>
            </Stepper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography component="h2" variant="subtitle1">
              Preview
            </Typography>
            {selectedId && <TreePreview inspectionId={selectedId} />}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!selectedId}
          onClick={() => selectCallback(selectedId, techId)}>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SelectDialog
